import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { router } from '@inertiajs/react'

// Import global CSS
import '../entrypoints/application.css'

// Show progress bar during page navigation
router.on('start', () => {
  // You could add a loading indicator here if desired
})

router.on('finish', () => {
  // And remove it here
})

createInertiaApp({
  // Set default page title
  title: title => title ? `${title} - Rezy` : 'Rezy',

  resolve: async (name) => {
    const pages = import.meta.glob('../pages/**/*.jsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.jsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.jsx'`)
    }
    
    return page
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(App, props))
    } else {
      console.error(
        'Missing root element.\n\n' +
          'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },
})
